import { useQuery } from 'react-query';
import { FacetInfo } from '../../../borrowed/catalog-app/typescript/src/app/model/types';
import { getSearchSuggestions } from '../../../borrowed/catalog-app/typescript/src/app/transport/api';

/**
 * Given the facet info, initial query, and list of indices, get the suggested type ahead values from the catalog.
 */
export const useCatalogSuggestions = (params: {
  facetInfo?: Pick<FacetInfo, 'name' | 'valueType'>;
  initialQuery?: string;
  indices?: Array<string>;
  limit: number;
}) => {
  return useQuery(
    [
      'suggestions',
      {
        facetInfo: params.facetInfo?.name,
        initialQuery: params.initialQuery,
        indices: params.indices,
      },
    ],
    () =>
      getSearchSuggestions({
        facetInfo: params.facetInfo,
        initialValue: params.initialQuery,
        indices: params.indices,
        limit: params.limit,
      }),
    { refetchOnWindowFocus: false, cacheTime: 60000 }
  );
};
